import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Box,
} from "@mui/material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Header from "./Header";

const discountItems = [
  {
    title: "50% Off on Vegetables",
    image: "https://source.unsplash.com/400x300/?vegetables,discount",
    offer: "Fresh veggies at half price!",
  },
  {
    title: "Buy 1 Get 1 Free - Snacks",
    image: "https://source.unsplash.com/400x300/?snacks,offer",
    offer: "Limited time snack sale!",
  },
  {
    title: "Dairy Combos @ ₹99",
    image: "https://source.unsplash.com/400x300/?dairy,products",
    offer: "Perfect combo for your kitchen.",
  },
  {
    title: "20% Off on Fruits",
    image: "https://source.unsplash.com/400x300/?fruits,shop",
    offer: "Eat fresh, live healthy!",
  },
];

const DiscountShop = () => {
  return (
    <Container sx={{ mt: 5, mb: 5, py:3 }}>
            <Header/>

      <Box textAlign="center" mb={4}>
        <LocalOfferIcon fontSize="large" color="success" />
        <Typography variant="h4" fontWeight={600}>
          💸 Today's Best Offers
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" mt={1}>
          Grab deals before they’re gone!
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {discountItems.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ boxShadow: 4, borderRadius: 3 }}>
              <CardMedia
                component="img"
                height="180"
                image={item.image}
                alt={item.title}
              />
              <CardContent>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  gutterBottom
                  sx={{ fontFamily: "Poppins" }}
                >
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.offer}
                </Typography>
              </CardContent>
              <CardActions>
                <Button fullWidth variant="contained" color="primary">
                  Shop Now
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default DiscountShop;
